import { render, staticRenderFns } from "./ParticipantsTableNew.vue?vue&type=template&id=54b6d434&scoped=true&"
import script from "./ParticipantsTableNew.vue?vue&type=script&lang=ts&"
export * from "./ParticipantsTableNew.vue?vue&type=script&lang=ts&"
import style0 from "./ParticipantsTableNew.vue?vue&type=style&index=0&id=54b6d434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b6d434",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VIcon,VSpacer,VTextField,VTooltip})
